import React, { useState } from "react";
import { Wrapper } from "./PriorityCardEntity.styled";
import { SuccessNotification, Spin, ErrorNotification, Popover } from "components/common";
import { callPostApi, callPutApi } from "utils/api";
import { getUserPermissions } from "utils/text";
import { MdDelete } from "react-icons/md";
import { FaMinus, FaPlus, FaUserPlus } from "react-icons/fa";
import { RiArrowUpSFill, RiArrowDownSFill } from "react-icons/ri";
import UserIcon from "../../../../assets/svg/boy-avatar.svg";

const CustomStyles = {
  popoverContainer: {
    padding: 10,
    maxWidth: 200
  },
  popoverTitle: {
    fontSize: 10,
    fontWeight: 600
  },
  popoverBtnContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: 10
  },
  popoverBtn: {
    border: "none",
    background: "#131f28",
    color: "white",
    borderRadius: "5px"
  }
}

const PriorityCardEntity = ({
  data, getUserApi, setIsAddUserLoading, color, borderColor, isDropAble, isAddUserLoading, isSmallScreen, isAdd, selectedUser, locationId, isDragging
}) => {
  const [appointValue, setAppointValue] = useState(
    Number(data?.allotCount) || data?.count || 0
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isAllowToDelete, SetIsAllowToDelete] = useState(false);
  const [isLoadingPlus, setIsLoadingPlus] = useState(false);
  const [isLoadingMinus, setIsLoadingMinus] = useState(false);

  const countPlus = () => {
    if (appointValue + 1 > 86) {
      return;
    }
    const val = appointValue + 1
    setIsLoadingPlus(true);
    setAppointValue(val);
    onPriorityChange(val);
  }
  const countMinus = () => {
    const val = Math.max(appointValue - 1, 0);
    setAppointValue(val)
    setIsLoadingMinus(true);
    onPriorityChange(val);
  }
  const errorSelectUserFirst = () => {
    ErrorNotification("Select a user to add");
  }
  const onPriorityChange = (e) => {
    let data_ = {
      priority: data?.priority,
      appointCount: e,
    };
    callPutApi(
      `/priority/update/closer/${data?._id}`,
      data_,
      () => {
        setIsLoadingPlus(false);
        setIsLoadingMinus(false);
        SuccessNotification("Rotation Count Updated");
        getUserApi();
      },
      () => {
        setIsLoadingPlus(false);
        setIsLoadingMinus(false);
      }
    );
  };
  const deleteUserFromRotation = () => {
    setIsLoading(true);
    SetIsAllowToDelete(false);
    callPostApi('/priority/remove/user/from/the/rotation/list', { userId: data?._id }, () => {
      getUserApi();
      setIsLoading(false);
    }, (err) => {
      console.log(err);
      setIsLoading(false);
    })
  }
  const addUser = () => {
    setIsAddUserLoading(true);
    callPostApi("/priority/update/user/location/to/current", { userId: selectedUser, locationId: locationId },
      () => { setIsAddUserLoading(false); getUserApi(); },
      () => { setIsAddUserLoading(false); ErrorNotification("Failed To Add User to location"); }
    );
  }

  const popOverContent = () => (
    <div style={CustomStyles.popoverContainer}>
      <div style={CustomStyles.popoverTitle}>Are you sure want to remove {data.username} from the list ?</div>
      <div style={CustomStyles.popoverBtnContainer}>
        <button style={CustomStyles.popoverBtn} onClick={deleteUserFromRotation}>Yes</button>
        <button style={CustomStyles.popoverBtn} onClick={() => SetIsAllowToDelete(false)}>No</button>
      </div>
    </div>
  )

  return (
    <Wrapper style={{ borderColor: borderColor }} isSmall={isSmallScreen} isDragging={isDragging}>
      {!isSmallScreen && (<div className="updownbuttons">
        <RiArrowUpSFill size={20} />
        <RiArrowDownSFill size={20} />
      </div>)}
      <div className="user-profile">
        <div className="image">
          {!isDropAble ? (
            <img src={data.profilePicture ? data.profilePicture : UserIcon} alt="User Image" />
          ) : (
            <>
              {!isAddUserLoading ? (
                <FaUserPlus size={24} cursor="pointer" onClick={isAdd ? addUser : errorSelectUserFirst} />
              ) : (<Spin spinning={isAddUserLoading} />)}
            </>
          )}
        </div>
        <div className="username" title={data?.username}>
          {data?.username}
        </div>
      </div>
      <div className="counter-input">
        {isLoadingMinus ? (
          <Spin spinning={isLoadingMinus} size={16} />
        ) : (
          <FaMinus cursor="pointer" onClick={isDropAble ? () => { } : countMinus} />
        )}
        <div className="count-box" style={{ backgroundColor: color }}>{appointValue}</div>
        {isLoadingPlus ? (
          <Spin spinning={isLoadingPlus} size={16} />
        ) : (
          <FaPlus cursor="pointer" onClick={isDropAble ? () => { } : countPlus} />
        )}
      </div>
      <div className="rotaion-text">
        {isSmallScreen ? (
          <div className="text-sm-sss">
            <span>Rotation Cycle:</span>
            <span>{`(${data?.count == null || data?.count == undefined || data?.count == "" ? 0 : data?.count} / ${data?.allotCount || data?.count || 0})`}</span>
          </div>
        ) : (
          <div className="text">
            Rotation Cycle: {`(${data?.count == null || data?.count == undefined || data?.count == "" ? 0 : data?.count} / ${data?.allotCount || data?.count || 0})`}
          </div>
        )}
      </div>
      <div className="rotaion-check">
        {getUserPermissions("edit-alot-count-action") && (
          <>{isLoading ? (
            <Spin spinning={isLoading} />
          ) : (
            <Popover placement="left" content={popOverContent} trigger="click" visible={isAllowToDelete}>
              <MdDelete color={isDropAble ? "#cccccc" : "#c80404"} size={isSmallScreen ? 20 : 24} cursor={isDropAble ? "none" : "pointer"} onClick={() => SetIsAllowToDelete(true)} />
            </Popover>
          )}</>
        )}
      </div>
    </Wrapper >
  );
};

export default PriorityCardEntity;
